import {
  AuthFormBoxTrueIdTemplate,
  TextBoxMaxLine1Headline2,
  TrueIdLoginButton,
} from '@setplex/arcana'
import { useUnit } from 'effector-react'
import type { JSX } from 'react'
import {
  TrueIdSignInErrorMessage,
  signInByTrueIdFeatureModel,
  model as signInModel,
} from '~/features/subscriber/sign-in'
import { $signInTrueIdFormTranslations } from './i18n'

export const SignInTrueIdForm = (): JSX.Element => {
  const formTranslations = useUnit($signInTrueIdFormTranslations)

  const trueIdSignInFx = useUnit(signInByTrueIdFeatureModel.trueIdSignInFx)

  const pendingTrueId = useUnit(
    signInByTrueIdFeatureModel.trueIdSignInFx.pending
  )
  const pendingSignin = useUnit(signInModel.signInFx.pending)
  const pending = pendingTrueId || pendingSignin

  const onTrueIdSignInFx = () => {
    trueIdSignInFx()
  }

  return (
    <AuthFormBoxTrueIdTemplate>
      <TextBoxMaxLine1Headline2 title={formTranslations.title} />

      <TrueIdLoginButton
        isLoading={pending}
        disabled={pending}
        onClick={onTrueIdSignInFx}
      />
      <TrueIdSignInErrorMessage />
    </AuthFormBoxTrueIdTemplate>
  )
}
